// /main.js

// 1. IMPORT the file (Don't fetch it)
import { RealTemperatureService } from './api/temperature.js';

// ... existing Three.js imports and setup ...

/**
 * Handles the 2D HUD updates separately from the 3D scene
 */
async function initDashboard() {
    const tempDisplay = document.getElementById('temp-value');
    const statusDisplay = document.getElementById('status');
    const statusDot = document.querySelector('.status-dot');

    // 1. Fetch Data
    const temp = await RealTemperatureService.fetchTemperature();

    //const temperature = await fetch('/api/warehouse')

    console.log(temp)
    //console.log("Temperature API response:", temperature);

    // DISABLED API STATUS FOR TEMP, BECAUSE WAREHOUSE ITEMS BEING LOADED TAKE PRIORITY AND THIS API IS NOT CRITICAL
    // 2. Update UI based on result
   
    if (temp !== null) {
        tempDisplay.textContent = temp.toFixed(1); // Ensure 1 decimal place
        
        // Update Status to Green
         /*
        statusDisplay.textContent = "ONLINE / API_OK";
        statusDisplay.style.color = "#00ff00"; 
        if(statusDot) statusDot.style.backgroundColor = "#00ff00";
                */
    } else {
        // Handle Error / Offline state
        /*
        statusDisplay.textContent = "CONNECTION_ERR";
        statusDisplay.style.color = "red";
        */
        if(statusDot) statusDot.style.backgroundColor = "red";
    }

}

// Start the data stream
initDashboard();

// Refresh every 120 seconds
setInterval(initDashboard, 120000);
